import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Form, Pagination, Modal, FormGroup } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import Search from '../../components/Search';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen, FillPlus } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';
import { Label } from '../../components/Label';
import { Autocomplete, TextField } from '@mui/material';

export function Cupons() {
    const [isLoading, setIsLoading] = useState(true);
    const [cupons, setCupons] = useState<any>([]);
    const [selectedCupom, setSelectedCupom] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);
    const [cupomSelecionado, setCupomSelecionado]: any = useState(null);
    const [dataExp, setDataExp]: any = useState(null);
    const [porcentagem, setPorcentagem]: any = useState(null);
    const [codigo, setCodigo] = useState("");
    const [produtos, setProdutos] = useState([])
    const [produtosSelecionados, setProdutosSelecionados]: any[] = useState();

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
    const filteredEmployees = cupons.filter((cupom: any) => {
        return (
            cupom.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
            cupom.id.toString().includes(searchQuery)
        );
    });

    const [showExcluir, setShowExcluir] = useState(false);
    const [reiniciarDataExpiracao, setReiniciarDataExpiracao] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [idSelected, setIdSelected] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const handleCloseExcluir = () => setShowExcluir(false);
    const handleCloseEditar = () => setShowEditar(false);

    useEffect(() => {
        const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
        const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
        const newCurrentFilteredEmployees = cupons.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

        setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    }, [currentPage, employeesPerPage, filteredEmployees]);

    const loadCupons = async () => {
        try {
            const response = await api.get('listar-cupons');
            setCupons(response.data.message ? [] : response.data);
            console.log(response.data)
            setSelectedCupom(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching coupon:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await api.get('produtos')
                setProdutos(response.data)
                console.log(response.data)
            } catch (error) {
                console.error(error)
                setAlert({ message: 'Ocorreu um erro ao buscar os produtos!', variant: 'danger', show: true });
            }
        }
        fetchProducts()
    }, []);

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1);
    };
    // Load companies initially
    useEffect(() => {
        loadCupons();
    }, []);

    const handleStatusChange = async (cupomId: any, currentStatus: any) => {
        try {
            if (currentStatus == 1) {
                await api.post(`cupons/ativar/${cupomId}`);
                setAlert({ show: true, message: 'Cupom ativado com sucesso! Foram adicionas 24 horas à data de expiração', variant: 'success' });
            } else {
                await api.post(`cupons/desativar/${cupomId}`);
                setAlert({ show: true, message: 'Cupom desativado com sucesso!', variant: 'success' });
            }
            loadCupons();
        } catch (error) {
            console.error("Error updating coupons status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(filteredEmployees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const handleSearchCupom = async (id: number) => {
        try {
            if (cupons.length > 0) {
                const finded = cupons.find((cupom: any) => cupom.id === id);
                setCodigo(finded.codigo);
                setPorcentagem(finded.desconto);
                setDataExp(finded.data_expiracao);
                setCupomSelecionado(id);
                setProdutosSelecionados(finded.produtos)
            } else {
                const response = await api.post(`buscar-dados-cupom/${id}`);
                setCodigo(response.data.cupom.codigo);
                setPorcentagem(response.data.cupom.desconto);
                setDataExp(response.data.cupom.data_expiracao);
                setCupomSelecionado(id);
                setProdutosSelecionados(response.data.cupomProdutos)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleEdit = (id: number) => {
        setShowEditar(true);
        handleSearchCupom(id);
    }

    const handleExcluir = (id: number) => {
        setShowExcluir(true);
        handleSearchCupom(id);
    }

    const copyToClipboard = (codigo: string) => {
        navigator.clipboard.writeText(codigo).then(() => {
            setAlert({ show: true, message: 'Código copiado com sucesso!', variant: 'success' });
        }).catch(err => {
            console.error('Erro ao copiar código: ', err);
            setAlert({ show: true, message: 'Erro ao copiar código.', variant: 'danger' });
        });
    };

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} às ${(date.getHours()).toString().padStart(2, '0')}h${date.getMinutes().toString().padStart(2, '0')}`;
        return formattedDate;
    };

    const handleExcluirCupom = async () => {
        try {
            await api.delete(`excluir-cupom-por-id/${cupomSelecionado}`);
            if (cupons.length > 0) {
                const novaLista = cupons.filter((cupom: any) => cupom.id !== cupomSelecionado);
                setCupons(novaLista);
            } else {
                loadCupons();
            }
            setShowExcluir(false);
        } catch (error) {
            setAlert({ show: true, message: 'Erro ao excluir cupom!', variant: 'danger' });
        }
    }

    const handleSubmitEdit = async () => {
        let isValid = true;

        if (!codigo) {
            setAlert({ message: 'Por favor, preencha o campo Código', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (!porcentagem) {
            setAlert({ message: 'Por favor, preencha o campo de porcentagem de desconto', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (isValid) {
            try {
                const formatDateTime = (date: any) => {
                    const d = new Date(date);
                    const pad = (n: any) => (n < 10 ? '0' + n : n);
                    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
                };
                const nome = codigo.replace(/\d+/g, '');
                const formattedDate = formatDateTime(dataExp);
                const payload = {
                    id: cupomSelecionado,
                    nome,
                    codigo,
                    desconto: porcentagem,
                    data_expiracao: dataExp,
                    reiniciarDataExpiracao: reiniciarDataExpiracao,
                    produtosSelecionados: produtosSelecionados
                }
                const response = await api.post('editar-cupom', payload);
                if (response.status === 200 || response.status === 204) {
                    setAlert({ show: true, message: 'Cupom editado com sucesso!', variant: 'success' });
                    setCodigo('');
                    setReiniciarDataExpiracao(false);
                    setPorcentagem(null);
                    setDataExp('');
                    setShowEditar(false)
                    loadCupons();
                }
            } catch (error) {
                console.error('Erro ao enviar dados do formulário:', error);
                setAlert({ show: true, message: 'Erro ao editar o cupom.', variant: 'danger' });
            }
        }


    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <Modal show={showExcluir} onHide={handleCloseExcluir}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Você tem certeza que deseja excluir este item?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseExcluir}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleExcluirCupom}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <CardContent>
                    <Row className='my-4'>
                        <Title text="Cupons de Desconto" />
                        <Col md={8}>
                            <Button className='newbutton' href={`cupons/cadastrar`}><FillPlus /> Novo Cupom</Button>
                        </Col>
                        <Col md={4}>
                            <Search placeHolder="Procure pelo código" onChange={handleSearchChange} />
                        </Col>
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(cupons.length / employeesPerPage)}</span>
                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="pgr-cupom-container">
                                <div className="pgr-cupom-wrapper">
                                    <table className="pgr-cupom-table">
                                        <thead>
                                            <tr>
                                                <th className="pgr-cupom-th">Cupom</th>
                                                <th className="pgr-cupom-th">Desconto</th>
                                                <th className="pgr-cupom-th">Data de Expiração</th>
                                                <th className="pgr-cupom-th">Produtos</th>
                                                <th className="pgr-cupom-th">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cupons.length > 0 ? (
                                                cupons.map((cupom: any) => (
                                                    <React.Fragment key={cupom.id}>
                                                        <tr>
                                                            <td className={`${(cupom.desativado == false) ? '' : 'pgr-cupom-text-danger'} pgr-cupom-td`}>
                                                                <div className="pgr-cupom-cell-content">
                                                                    {cupom.codigo}
                                                                </div>
                                                            </td>
                                                            <td className={`${(cupom.desativado == false) ? '' : 'pgr-cupom-text-danger'} pgr-cupom-td`}>
                                                                <div className="pgr-cupom-cell-content">
                                                                    {cupom.desconto + '%'}
                                                                </div>
                                                            </td>
                                                            <td className={`${(cupom.desativado == false) ? '' : 'pgr-cupom-text-danger'} pgr-cupom-td`}>
                                                                <div className="pgr-cupom-cell-content">
                                                                    {formatDate(cupom.data_expiracao)}
                                                                </div>
                                                            </td>
                                                            <td className={`${(cupom.desativado == false) ? '' : 'pgr-cupom-text-danger'} pgr-cupom-td`}>
                                                                <div className="pgr-cupom-cell-content">
                                                                    {cupom.produtos && cupom.produtos.length > 0 ? (
                                                                        <ul>
                                                                            {cupom.produtos.map((produto: any) => (
                                                                                <li key={produto.id}>{produto.nome}</li>
                                                                            ))}
                                                                        </ul>
                                                                    ) : (
                                                                        <span>Sem produtos associados</span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="pgr-cupom-td">
                                                                <div className="pgr-cupom-button-group">
                                                                    {cupom.desativado !== false && (
                                                                        <Button className="pgr-cupom-button" onClick={() => copyToClipboard(cupom.codigo)}>Copiar Código</Button>
                                                                    )}
                                                                    <Button className="pgr-cupom-button" variant='outline-main' onClick={() => handleEdit(cupom.id)}>Editar</Button>
                                                                    <Button
                                                                        className="pgr-cupom-button"
                                                                        variant={`${(cupom.desativado === false) ? 'outline-danger' : 'outline-success'}`}
                                                                        onClick={() => handleStatusChange(cupom.id, cupom.desativado)}
                                                                    >
                                                                        {(cupom.desativado == false) ? 'Desativar' : 'Ativar'}
                                                                    </Button>
                                                                    <Button className="pgr-cupom-button" variant='outline-danger' onClick={() => handleExcluir(cupom.id)}>Excluir</Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="pgr-cupom-text-center">
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
                <Modal show={showEditar} onHide={handleCloseEditar}>
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Cupom</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmitEdit}>
                            <div style={{ marginTop: '10px' }}><Label title='Código' htmlFor="nome" /></div>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <input
                                            type="text"
                                            id="nome"
                                            placeholder="Digite o Código do Cupom"
                                            value={codigo}
                                            onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                                            style={{ width: '50%', marginTop: '10px', padding: '10px', borderRadius: '6px', border: '1px solid lightgray', fontSize: '13px' }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div style={{ marginTop: '10px' }}><Label title='Desconto' htmlFor="descricao" /></div>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <input
                                            id="descricao"
                                            type='number'
                                            placeholder="Digite a porcentagem"
                                            value={porcentagem}
                                            onChange={(e) => setPorcentagem(e.target.value)}
                                            style={{ width: '50%', marginTop: '10px', padding: '10px', borderRadius: '6px', border: '1px solid lightgray', fontSize: '13px' }} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div style={{ marginTop: '10px' }}>
                                <Label title='Deseja reiniciar o prazo de validade de 24 horas a partir da data de edição?' htmlFor="dataExp" />
                            </div>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <div id='dataExp' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                                            <div>
                                                <input type="checkbox"
                                                    checked={reiniciarDataExpiracao}
                                                    onClick={() => setReiniciarDataExpiracao(!reiniciarDataExpiracao)}
                                                    style={{ marginRight: '5px', cursor: 'pointer' }} />Sim
                                            </div>
                                            <div>
                                                <input type="checkbox"
                                                    checked={!reiniciarDataExpiracao}
                                                    onClick={() => setReiniciarDataExpiracao(!reiniciarDataExpiracao)}
                                                    style={{ marginRight: '5px', marginLeft: '15px', cursor: 'pointer' }} />Não
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <Autocomplete
                                            multiple
                                            options={[{ id: 'todos', nome: 'TODOS' }, ...produtos.filter((produto: any) =>
                                                produtosSelecionados && !produtosSelecionados.some((selected: any) => selected.id === produto.id))]}
                                            getOptionLabel={(option: any) => option.nome}
                                            value={produtosSelecionados || []} // Garantindo que seja um array
                                            onChange={(_, newValue: any) => {
                                                if (newValue.some((option: any) => option.id === 'todos')) {
                                                    if (!produtosSelecionados.some((item: any) => item.id === 'todos')) {
                                                        setProdutosSelecionados([...produtos]);
                                                    } else {
                                                        setProdutosSelecionados([]);
                                                    }
                                                } else {
                                                    setProdutosSelecionados(newValue);
                                                }
                                            }}
                                            renderInput={(params: any) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder={
                                                        produtosSelecionados.length === 0
                                                            ? "Selecione os produtos que deseja aplicar o cupom"
                                                            : ""
                                                    }
                                                    size="small"
                                                    style={{
                                                        width: '100%',
                                                        padding: '0.4rem',
                                                        fontSize: '0.875rem',
                                                        backgroundColor: 'white',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            )}
                                            style={{
                                                width: '100%',
                                                fontSize: '0.875rem'
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseEditar}>
                            Cancelar
                        </Button>
                        <Button variant="success" onClick={handleSubmitEdit}>
                            Salvar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div >
    );
}